<template>
    <div class="billing-address" v-if="!sameAsShippingAddress">
        <div class="billing-address__checkbox-container">
            <div class="billing-address__checkbox billing-address__checkbox--national">
                <input
                    id="national"
                    type="radio"
                    name="billing_address_type"
                    value="national"
                    v-validate="sameAsShippingAddress ? 'required' : ''"
                    v-model="billingAddressType"
                />
                <span class="billing-address__checkbox-checkmark" />
                <label for="national" v-text="$ml.get('national')" />
            </div>

            <div class="billing-address__checkbox billing-address__checkbox--international">
                <input
                    id="international"
                    type="radio"
                    name="billing_address_type"
                    value="international"
                    v-validate="sameAsShippingAddress ? 'required' : ''"
                    v-model="billingAddressType"
                />
                <span class="billing-address__checkbox-checkmark" />
                <label for="international" v-text="$ml.get('international')" />
            </div>
        </div>

        <div class="billing-address__address-container">
            <Address
                :zip-code.sync="zipCode"
                :street.sync="street"
                :address-line2.sync="addressLine2"
                :number.sync="number"
                :complement.sync="complement"
                :district.sync="district"
                :city.sync="city"
                :state.sync="state"

                :disable-street="disableStreet"
                :disable-district="disableDistrict"
                :disable-city="disableCity"
                :disable-state="disableState"

                :is-international="isNational === false"

                :address-errors.sync="innerAddressErrors"

                :show-country-select="true"

                @postalCodeFetched="onZipCodeFetched"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Address from '@/components/Address';
    import { attr_accessor } from '@/services/VuexAcessor';

    export default {
        components: {
            Address
        },

        data() {
            return {
                innerAddressErrors: {}
            };
        },

        mounted() {
             this.$emit('update:addressErrors', this.innerAddressErrors);
        },

        computed: {
            ...mapGetters({
                sameAsShippingAddress: 'billingAddress/getSameAsShippingAddress',
                isNational: 'billingAddress/getIsNational'
            }),

            disableStreet: self => false,
            disableDistrict: self => false,
            disableCity: self => self.fetchedFields.includes('city'),
            disableState: self => self.fetchedFields.includes('state'),

            /**
             * Dados a serem sincronizados com o storage
             */
            billingAddressType: attr_accessor(state => state.billingAddress.Type, 'billingAddress/setType'),
            zipCode: attr_accessor(state => state.billingAddress.ZipCode, 'billingAddress/setZipCode'),
            street: attr_accessor(state => state.billingAddress.Street, 'billingAddress/setStreet'),
            addressLine2: attr_accessor(state => state.billingAddress.AddressLine2, 'billingAddress/setAddressLine2'),
            number: attr_accessor(state => state.billingAddress.Number, 'billingAddress/setNumber'),
            complement: attr_accessor(state => state.billingAddress.Complement, 'billingAddress/setComplement'),
            district: attr_accessor(state => state.billingAddress.District, 'billingAddress/setDistrict'),
            city: attr_accessor(state => state.billingAddress.City, 'billingAddress/setCity'),
            state: attr_accessor(state => state.billingAddress.State, 'billingAddress/setState'),

            fetchedFields:{
                get: self => self.$store.state.billingAddress.FetchedFields
            },
        },

        watch: {
            billingAddressType(value) {
                if (value) {
                    if (!this.$refs.billing_address_type) return;
                    this.$refs.billing_address_type.style.visibility = 'visible';
                }
            }
        },

        methods: {
            onZipCodeFetched(response) {
                this.$store.commit('billingAddress/setFromRequest', response.fields);
            }
        },

        props: {
            addressErrors: {
                type: Object,
                default() {
                    return {};
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .billing-address {
        margin-top: 20px;

        &__checkbox-container {
            display: none;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
        }

        &__checkbox {
            position: relative;
            display: flex;
            align-items: center;

            input {
              position: absolute;
              opacity: 0;
              cursor: pointer;
              height: 24px;
              width: 24px;
              z-index: 1;

              &:checked ~ .billing-address__checkbox-checkmark {
                  &::after {
                    background-color: #0774E7;
                  }
              }
            }

            label {
              font-size: 16px;
              font-weight: 500;
              line-height: 16px;
              color: #2F363E;
              margin: 0;
              cursor: pointer;
            }

        }


        &__checkbox--international {}

        &__checkbox--national {}

        &__checkbox-checkmark {
          display: block;
          width: 24px;
          height: 24px;
          border: 1px solid #0774E7;
          margin-right: 12px;
          border-radius: 12px;
          position: relative;
          cursor: pointer;

          &::after {
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 12px;
              height: 12px;
              border-radius: 6px;
          }
        }
    }

</style>
